import { createContext, useState, useEffect, useContext } from 'react';
import apiClient from '../api/apiClient';
import useAuth from '../hooks/useAuth';

const DailyActionsContext = createContext();

export const DailyActionsProvider = ({ children }) => {
    const [dailyData, setDailyData] = useState(null);
    const [loading, setLoading] = useState(true);
    const { user } = useAuth();

    const fetchDailyActions = async () => {
        if (!user) return;
        try {
            const res = await apiClient.get('/daily-actions');
            setDailyData(res.data);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching daily actions', error);
            setLoading(false);
        }
    };

    useEffect(() => {
        if (user) {
            fetchDailyActions();
        } else {
            setDailyData(null);
        }
    }, [user]);

    const toggleAction = async (actionName) => {
        if (!dailyData) return;

        const updatedActions = dailyData.actions.map((action) =>
            action.name === actionName
                ? { ...action, completed: !action.completed }
                : action
        );

        // Optimistic update
        setDailyData({ ...dailyData, actions: updatedActions });

        try {
            const res = await apiClient.put('/daily-actions', {
                date: dailyData.date,
                actions: updatedActions,
            });
            setDailyData(res.data);
        } catch (error) {
            console.error('Error updating action', error);
            // Revert on error (optional, but good practice)
            fetchDailyActions();
        }
    };

    return (
        <DailyActionsContext.Provider value={{ dailyData, loading, toggleAction, fetchDailyActions }}>
            {children}
        </DailyActionsContext.Provider>
    );
};

export const useDailyActions = () => {
    return useContext(DailyActionsContext);
};
